<template>
  <div class="hyActivity">
    <navtab class="navTab"></navtab>
    <div class="top" :style="{height:topImgParHeight+'px'}">
        <div class="leftImgDiv">
            <img :src="newsMes.headerImage" alt="">
        </div>
        <ul class="rightWord">
            <li class="rightWordTime">{{newsMes.createtime}}</li>
            <li class="rightWordTitle">{{newsMes.name}}</li>
            <!-- <li class="rightWordDesc"   v-html="newsMes.content" ref="newsDetail"></li> -->
            <li class="rightWordBtn" @click="toHyActivityDetail(newsMes.industryid,newsMes.id)">查看详情</li>
        </ul>
    </div>
    <ul class="tabUl">
      <li :class="['tabLi',index==current?'active':'']" v-for="(val,index) in typeList" :key="index" index="index" @click="getHy(val.id)">{{val.name}}</li>
      <!-- <li class="tabLi">typeasdc1</li>
      <li class="tabLi">type1sacascas</li> -->
    </ul>
    <ul class="listInfo">
        <li v-for="(val,index) in endNewsList " :key="index" :style="{height:heightScOne+'px'}" @click="toHyActivityDetail(val.industryid,val.id)">
            <div class="imgPar">
              <!-- <h1>1111</h1> -->
                <img :src="val.headerImage" alt="">
            </div>
            <div class="lef">
              <p class="listInfoTime el-icon-time">   {{val.createtime}}</p>
              <p class="listInfoTitle">{{val.name}}</p>
              <!-- <p class="listInfoDesc" v-html="val.content"></p> -->
            </div>

        </li>
    </ul>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="24"
      :current-page="currentPage"
      @current-change="changePage"
      :total=total>
    </el-pagination>
    <!-- <div class="address" v-html="htmlWord"></div> -->
  </div>
</template>

<script>
import $ from "jquery";
import navtab from "./navtab";
export default {
  name: "hyActivity",
  components: {
    navtab: navtab
  },
  data() {
    return {
      htmlWord:
      "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      currentPage:1,
      total:0,
      newsList: "",
      listObj: [],
      user: "",
      secondListObj: [],
      headerImage: "",
      createtime: "",
      name: "",
      content: "",
      industryid: "",
      detailId: "",
      typeList: [],
      newsMes:{},
      current:0,
      endNewsList:[],
      heightScOne:"",
      topImgParHeight:""
    };
  },

  methods: {
    changePage(currentPage){
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.currentPage=currentPage;
      this.total=parseInt(this.newsList.length);
      //console.log(currentPage);
      //console.log(
      //  this.newsList
      // );
      let start = 24 * (this.currentPage - 1);
      let end = 24 * (this.currentPage - 1) + 24;
      //console.log(start, end);
      this.endNewsList = this.newsList.slice(start, end);
      //console.log(this.endNewsList);
    },
    // 获取目标元素，返回数组
    exampleSolve(domele) {
      //console.log(domele);
      //console.log(domele.getElementsByTagName("img"));
      this.$nextTick(() => {
        let imgArr = domele.getElementsByTagName("img");
        //console.log(imgArr);
        this.handleStyle(imgArr);
        let videoArr = domele.getElementsByTagName("video");
        //console.log(videoArr);
        this.handleStyle(videoArr);
      });
    },
    // 处理富文本中的img 和 video标签元素
    handleStyle(ele) {
      let elem = ele;
      for (let i = 0; i < elem.length; i++) {
        $(elem[i]).css({
          display: "none"
        });
      }
    },
    toHyActivityDetail(industryid, detailId) {
      //console.log(industryid, detailId);
      this.$router.push("/hyActivityDetail/" + industryid + "/" + detailId);
    },
    //  获取行业动态分类列表 /api/Home/Industry 行业分类
    getType() {
      //console.log("111");
      this.$axios({
        method: "get",
        url: this.$http + "api/Home/Industry"
      })
        .then(res => {
          if (res.data.code == 0) {
            //console.log(res.data);
            this.typeList = res.data.Entity;
            //console.log(this.typeList);
            this.getHy(this.typeList[0].id);
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },
    // 获取具体的行业新闻  /api/Home/SelectDynamic/{IndustryId}通过行业分类ID查询行业
    getHy(typeid) {
      //console.log("222");
      //console.log(typeid);
      this.$axios
        .get(this.$http + "api/Home/SelectDynamic/" + typeid)
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取成功");
            //console.log(res.data);
            //console.log(res.data.Entity);
            var ind= res.data.Entity.length-1;  
            //console.log(ind);
            this.newsMes= res.data.Entity[ind];
            this.newsList = res.data.Entity;
            this.changePage(this.currentPage);
            // this.newsList = this.newsList.slice(0, 4);
            // //console.log(this.newsList);
            // for (let index = 0; index < this.newsList.length; index++) {
            //   //console.log(index);
            //   //console.log(index, this.newsList[index].id);
            //   this.getnewsDetail(this.newsList[index].id);
            // }
          } else {
            //console.log("获取失败");
          }
        })
        .catch(err => {});
    },
    // 获取新闻详情 /api/Home/SelectDynamicByID/{dynamicId}/{userName}通过行业ID查询详情
    getnewsDetail(dynamicId) {
      this.$axios
        .get(
          this.$http +
            "api/Home/SelectDynamicByID/" +
            dynamicId +
            "/" +
            this.user.userName
        )
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取新闻详情 成功");
            //console.log(res.data);
            this.newsDetail = res.data.Entity;
            this.listObj.push(this.newsDetail);
            //console.log(this.listObj);
            this.firstMes=
            this.headerImage = this.listObj[0].headerImage;
            this.createtime = this.listObj[0].createtime;
            this.name = this.listObj[0].name;
            this.industryid = this.listObj[0].industryid;
            this.detailId = this.listObj[0].industryid;
            this.content = this.listObj[0].content;
            //console.log(this.industryid, this.detailId);
            this.secondListObj = this.listObj.slice(1, 4);
            //console.log(this.secondListObj);
            this.exampleSolve(this.$refs.newsDetail);
          } else {
            //console.log("获取新闻详情 失败");
          }
        })
        .catch(err => {});
    }
  },

  created() {},
  mounted() {
    var imgWidth=document.body.clientWidth*0.8*0.49*0.45;
    //console.log(imgWidth);
    this.heightScOne=(imgWidth*116)/170;
    //console.log(this.heightScOne);
    //console.log(imgWidth/this.heightScOne,170/116);
    this.topImgParHeight=(document.body.clientWidth*0.8*0.36*116)/170;
    this.user = sessionStorage.getItem("user");
    this.getType();
  }
};
</script>

<style scoped>
/* <ul class="tabUl">
      <li class="tabLi">type1</li>
      <li class="tabLi">type1</li>
      <li class="tabLi">type1</li>
    </ul> */
.hyActivity {
  width: 100%;
  background-color: #fff;
}
.hyActivity .tabUl {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  height: 50px;
  /* background-color: pink; */
  margin: 21px auto;
  border-bottom: 1px solid #158DD3;
}
.hyActivity .tabUl li {
  margin: 0 10px 0 0;
  height: 50px;
  line-height: 50px;
  text-align: center;
  /* color: black;
  background-color: #f1f1f1; */

  
  background: #EEEEEE;
  color:#666666;
  font-size: 14px;
  padding: 0 12px;
  cursor: pointer;
  min-width: 100px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: #158DD3;
color: #fff;
}
.hyActivity .tabUl li.active {
  
  background-color: #158DD3;
color: #fff;
}
.hyActivity .tabUl li:hover {
  background-color: #158DD3;
  color: #fff;
}
.hyActivity .navTab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index:999;
}
.hyActivity .top {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 438px;
  margin: 0 auto;
  margin-top: 30px;
}
.hyActivity .top .leftImgDiv {
  width: 36%;
  height: 100%;
  position: relative;
}
.hyActivity .top .leftImgDiv img {
display: block;
    max-width: 100%;
    min-width: 80%;
    min-height: 80%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.hyActivity .top .rightWord {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 50%;
  /* background-color: pink; */
  margin-left: 10%;
}
.hyActivity .top .rightWord li {
  width: 100%;
  text-align: left;
  line-height: 30px;
  color: black;
  /* margin: 2% 0; */
}
.hyActivity .top .rightWord .rightWordTime {
  font-size: 14px;
  color: #777777;
  margin-top: 5%;
}
.hyActivity .top .rightWord .rightWordTitle {
  font-size: 24px;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  /* height: 100px; */
  margin-top: 15px;
}
.hyActivity .top .rightWord .rightWordDesc {
  font-size: 14px;
  color: black;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 155px;
}
.hyActivity .top .rightWord .rightWordBtn {
  display: block;
  width: 23%;
  height: 48px;
  line-height: 48px;
  background-color:#158DD3;
  text-align: center;
  font-size: 14px;
  color: #fff;
  /* font-weight: 600; */
  cursor: pointer;
  margin-top: 30px;
}
.hyActivity .listInfo {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* margin-top: 3%; */
  padding-bottom: 20px;
  /* height: 400px; */
  flex-wrap: wrap;
}
.hyActivity .listInfo li {
display: inline-block;
    width: 49%;
    height: 211px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    cursor: pointer;
    /* background-color: pink; */
    margin-bottom: 20px;
    border: 1px solid #e2e2e2;
    background: rgba(255,255,255,1);
    border: 1px solid rgba(210,210,210,1);
    box-shadow: 0px 10px 20px 0px rgba(74,74,74,0.1);
}
.hyActivity .listInfo li .imgPar {
  width: 45%;
  height: 100%;
  position: relative;
  /* background-color: blue; */
}
.hyActivity .listInfo li .lef{
  width: 50%;
  /* background-color: green; */
  margin-left: 10px;
}
.hyActivity .listInfo li .lef p {
  margin-top: 2%;
}
.hyActivity .listInfo li .imgPar img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%)
}
.hyActivity .listInfo li .lef .listInfoTime {
  width: 100%;
  text-align: left;
  /* padding-left: 20px; */
  font-size: 14px;
  color: #9e9e9e;
  margin-top:30px;
}
.hyActivity .listInfo li .lef .listInfoTitle {
    text-align: left;
    display: block;
    /* height: 30px!important; */
    /* padding-left: 20px; */
    font-size: 14px;
    line-height: 30px;
    color: black;
    width: 100%;
    font-weight: 600;
    margin-top: 10px;
}
.hyActivity .listInfo li .lef .listInfoDesc {
  /* 前几行均匀分布，最后一行左对齐 */
  text-align: justify;
  text-align-last: left;
  -moz-text-align-last: left;
  height: 80px;
  /* padding-left: 20px; */
  font-size: 14px;
  line-height: 25px;
  color: black;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* -webkit-line-clamp: 1; */
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical; */
}
.hyActivity .el-pagination{
  padding-bottom: 32px;
}
/* <ul class="listInfo">
        <li>
            <div class="imgPar">
                <img src="../assets/3.png" alt="">
            </div>
            <p class="listInfoTime">2019/03/22</p>
            <p class="listInfoTitle">凯迪拉克电磁阀故障，亮发动机故障灯！</p>
            <p class="listInfoDesc">22万公里的凯迪拉克2.0T，到店进行汽车保养，汽车维修师傅在对车子进行全面检查时发现发动机故障灯亮。询问车主
                得知，该故障灯亮了很长时间，但驾驶起来没什么问题，就没有太在意。汽车维修师傅用电脑检查故障码为P0299发动机
                增压不...
            </p>
</li> */
/* .hyActivity .address {
  width: 80%;
  margin: 30px auto;
  margin-bottom: 0;
  font-size: 12px;
  color: gray;
  padding-bottom: 32px;
} */
</style>


// WEBPACK FOOTER //
// src/components/hyActivity.vue